<!-- Dashboard -->

<ng-container *ngFor="let section_menu of SYSTEM_NAVIGATION_MENU">
  @if (section_menu.type === 'item') {
  <!-- Menu Item -->
  <ng-container
    [ngTemplateOutlet]="item"
    [ngTemplateOutletContext]="{ menu: section_menu }"
  ></ng-container>
  } @else if (section_menu.type === 'section') {
  <!-- Menu Section -->
  <ng-container
    [ngTemplateOutlet]="section"
    [ngTemplateOutletContext]="{ menu: section_menu }"
  ></ng-container>
  } @else if (section_menu.type === 'accordion') {
  <!-- Menu Accordion -->
  <ng-container
    [ngTemplateOutlet]="accordion"
    [ngTemplateOutletContext]="{ menu: section_menu }"
  ></ng-container>
  }
</ng-container>

<!-- Template Menu Item -->
<ng-template #item let-menu="menu">
  <div class="menu-item me-lg-1">
    <a
      class="menu-link py-3"
      routerLinkActive="active menu-here"
      [routerLink]="menu.url"
    >
      <span class="menu-title">{{ menu.title | translate }}</span>
    </a>
  </div>
</ng-template>

<!-- Template Menu Accordion -->
<ng-template #accordion let-menu="menu">
  <div
    class="menu-item menu-lg-down-accordion me-lg-1 menu-dropdown"
    data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
    data-kt-menu-placement="bottom-start"
  >
    <span
      class="menu-link py-3"
      [ngClass]="calculateMenuItemCssClass(menu.url!)"
    >
      <span class="menu-title header-menu-title">{{
        menu.title | translate
      }}</span>
      <span class="menu-arrow d-lg-none"></span>
    </span>

    <div
      class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px"
      data-kt-menu-dismiss="true"
      data-popper-placement="bottom-start"
    >
      <ng-container *ngFor="let sub_menu of menu.children">
        @if (sub_menu.type=== 'accordion') {
        <div
          class="menu-item menu-lg-down-accordion me-lg-1"
          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
          data-kt-menu-placement="right-start"
        >
          <span
            class="menu-link py-3"
            [ngClass]="calculateMenuItemCssClass(sub_menu.url!)"
          >
            <span class="menu-bullet">
              <span class="bullet bullet-dot"></span>
            </span>
            <span class="menu-title" [attr.data-link]="sub_menu.url"
              >{{ sub_menu.title | translate }}
            </span>
            <span class="menu-arrow"></span>
          </span>

          <div
            class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px"
            data-kt-menu-dismiss="true"
          >
            <div
              *ngFor="let children of menu.children"
              class="menu-item me-lg-1"
            >
              <a
                class="menu-link py-3"
                routerLinkActive="active"
                [routerLink]="children.url"
              >
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">{{ children.title | translate }}</span>
              </a>
            </div>
          </div>
        </div>
        }@else {
        <div class="menu-item me-lg-1">
          <a
            class="menu-link py-3"
            routerLinkActive="active menu-here"
            [routerLink]="sub_menu.url"
          >
            @if (sub_menu.icon!.length) {
            <span class="menu-icon">
              <app-keenicon
                [name]="sub_menu.icon!"
                class="fs-2 svg-icon svg-icon-2"
              ></app-keenicon>
            </span>
            }@else {
            <span class="menu-bullet">
              <span class="bullet bullet-dot"></span>
            </span>
            }
            <span class="menu-title">{{ sub_menu.title | translate }}</span>
          </a>
        </div>
        }
      </ng-container>
    </div>
  </div>
</ng-template>

<!-- Template Menu Section -->
<ng-template #section let-menu="menu">
  <div
    class="menu-item menu-lg-down-accordion me-lg-1 menu-dropdown"
    data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
    data-kt-menu-placement="bottom-start"
  >
    <span
      class="menu-link py-3"
      [ngClass]="calculateMenuItemCssClass(menu.url!)"
    >
      <span class="menu-title header-menu-title">{{
        menu.title | translate
      }}</span>
      <span class="menu-arrow d-lg-none"></span>
    </span>

    <div
      class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px"
      data-kt-menu-dismiss="true"
      data-popper-placement="bottom-start"
    >
      <div
        *ngFor="let sub_menu of menu.children"
        class="menu-item me-lg-1 menu-lg-down-accordion"
        data-kt-menu-trigger="{default:'click', lg: 'hover'}"
        data-kt-menu-placement="right-start"
      >
        <!-- Menu Section with accordion -->
        @if ( sub_menu.type === 'accordion') {
        <span
          class="menu-link py-3"
          [ngClass]="calculateMenuItemCssClass(sub_menu.url!)"
        >
          @if (sub_menu.icon!.length) {
          <span class="menu-icon">
            <app-keenicon
              [name]="sub_menu.icon!"
              class="fs-2 svg-icon svg-icon-2"
            ></app-keenicon>
          </span>
          }@else {
          <span class="menu-bullet">
            <span class="bullet bullet-dot"></span>
          </span>
          }
          <span class="menu-title">{{ sub_menu.title | translate }}</span>

          <span class="menu-arrow"></span>
        </span>
        <div
          class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px"
          data-kt-menu-dismiss="true"
        >
          <ng-container *ngFor="let children of sub_menu.children">
            <!-- menu accordion in accordion -->
            @if (children.type=== 'accordion') {
            <div
              class="menu-item menu-lg-down-accordion me-lg-1"
              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
              data-kt-menu-placement="right-start"
            >
              <span
                class="menu-link py-3"
                [ngClass]="calculateMenuItemCssClass(children.url!)"
              >
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title" [attr.data-link]="children.url"
                  >{{ children.title | translate }}
                </span>
                <span class="menu-arrow"></span>
              </span>

              <div
                class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px"
                data-kt-menu-dismiss="true"
              >
                <div
                  *ngFor="let sub_children of children.children"
                  class="menu-item me-lg-1"
                >
                  <a
                    class="menu-link py-3"
                    routerLinkActive="active"
                    [routerLink]="sub_children.url"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">{{
                      sub_children.title | translate
                    }}</span>
                  </a>
                </div>
              </div>
            </div>
            } @else {
            <!-- menu item in accordion -->
            <div class="menu-item me-lg-1">
              <a
                class="menu-link py-3"
                routerLinkActive="active menu-here"
                [routerLink]="children.url"
              >
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">{{ children.title | translate }}</span>
              </a>
            </div>
            }
          </ng-container>
        </div>
        }
        <!-- Menu Section with item -->
        @if ( sub_menu.type === 'item') {
        <a
          class="menu-link py-3"
          routerLinkActive="active"
          [routerLink]="sub_menu.url"
        >
          @if (sub_menu.icon!.length) {
          <span class="menu-icon">
            <app-keenicon
              [name]="sub_menu.icon!"
              class="fs-2 svg-icon svg-icon-2"
            ></app-keenicon>
          </span>
          }@else {
          <span class="menu-bullet">
            <span class="bullet bullet-dot"></span>
          </span>
          }
          <span class="menu-title">{{ sub_menu.title | translate }}</span>
        </a>
        }
      </div>
    </div>
  </div>
</ng-template>
